import { FC } from 'react'
import { DashboardCardProps, DashboardSingleClientPlan } from './types.d'
import { Button, ButtonGroup } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Plan: FC<DashboardCardProps> = ({ widgetData }) => {
    const currentPlan = Object.values(widgetData.plans).filter(
        (p: DashboardSingleClientPlan) => p.active === true
    )?.[0] as DashboardSingleClientPlan

    return (
        <div className="stat-card">
            <div
                className="stat-card__accent"
                style={{ background: 'linear-gradient(90deg, #0a63ea, #3b82f6)' }}
            />
            <div className="stat-card__header">
                <div>
                    <div className="stat-card__label text-primary">Plan</div>
                    <div className="stat-card__value text-primary">
                        {currentPlan.label}
                    </div>
                </div>
                <div
                    className="stat-card__icon"
                    style={{ background: 'linear-gradient(135deg, #0a63ea, #083bb0)' }}
                >
                    <FontAwesomeIcon icon={['fas', 'hand-holding-dollar']} />
                </div>
            </div>
            <div className="stat-card__action">
                <ButtonGroup className="w-100">
                    {Object.keys(widgetData.plans).map((planCode: string) => {
                        const plan: DashboardSingleClientPlan =
                            widgetData.plans[planCode]
                        return plan.active ? (
                            <Button
                                key={planCode}
                                variant="outline-primary"
                                size="sm"
                                disabled
                            >
                                {plan.label}
                            </Button>
                        ) : (
                            <Link
                                key={planCode}
                                to={process.env.REACT_APP_UPGRADE_PLAN_URL}
                                target="_blank"
                                className="btn btn-outline-primary btn-sm"
                            >
                                {plan.label}
                            </Link>
                        )
                    })}
                </ButtonGroup>
            </div>
        </div>
    )
}

export default Plan
